<template>
  <div class="">
    <top-header :type="3" :isShow="false" :bgColor="bgColor" :textColor="textColor" />
    <div class="top_banner" ref="topBanner">
      <swiper class="swiper" :options="swiperOptionh" ref="mySwiper">
        <swiper-slide class="slide_video_con" v-for="(item, index) in swiperImg" :key="index">
          <img  :src="imgPath + 'sClf/' + item.fileId + '.jpg'" alt="">
        </swiper-slide>
        <swiper-slide v-if="!swiperImg.length">
          <img v-lazy="" alt="">
        </swiper-slide>
      </swiper>
      <div class="total" v-if="swiperImg.length">{{topSwiperIndex + 1}} / {{swiperImg.length}}张</div>
    </div>
    <h4 class="title">{{obj.xmmc}}</h4>
    <div class="row_con m_flex_box flex_jz">
      <div class="inner">
        <p class="col_red">{{obj.listedPrice ? obj.listedPrice/10000 : '暂无'}}万</p>
        <p class="tit">售价</p>
      </div>
      <div class="inner">
        <p class="col_red">{{obj.zmjCount}}m²</p>
        <p class="tit">建筑面积</p>
      </div>
      <div class="inner">
        <p class="col_red">{{obj.yt ? obj.yt : '-'}}</p>
        <p class="tit">用途</p>
      </div>
      <div class="inner">
        <p class="col_red">{{obj.xzqh}}</p>
        <p class="tit">区域</p>
      </div>
    </div>
    <div class="content">{{obj.content}}</div>
    <div class="pad_b"></div>
    <div class="btn_con">
      <a @click="callTo(obj.phone, 1, id)" class="m_flex_box flex_vc flex_hc">
        <img src="@/assets/img/btn_phone.png" alt="">
        <span>拨打电话</span>
      </a>
    </div>
  </div>
</template>

<script>
import topHeader from '@/components/header'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import qs from "qs";
export default {
  data() {
    return {
      topSwiperIndex: 0,
      textColor: '#fff',
      bgColor: 'transparent',
      swiperImg: [],
      swiperOptionh: {
        on: {
          slideChangeTransitionStart: (data) =>{
            this.topSwiperIndex = data.activeIndex;
          },
        },
        pagination: {
        }
      },
      obj: '',
      id: this.$route.query.listedId
    };
  },
  components: {
    topHeader,
    Swiper,
    SwiperSlide,
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    callTo(phone, lx, infoId) {
      if(!phone) {
        this.$dialog.alert({
          title: '提示',
          message: '暂无可拨打电话'
        });
        return;
      }
      this.$new.post('telTj/addTeltj.do', qs.stringify({
        phone,
        lx,
        infoId
      })).then(res => {
        window.location.href = `tel:${phone}`
      })
    },
    getDetail() {
      this.$http.post('cms/companyHouseListed/permit/houseListedInfo.do', qs.stringify({
          listedId: this.id,
        })).then(res => {
          if (res.success) {
            this.obj = res.obj
            this.swiperImg = res.obj.roomImg
          } else {
            this.$toast('获取详情失败!');
          }
        })
    },
  },
};
</script>
<style lang="less" scoped>
.top_banner{
    position: relative;
    height: 5.64rem;
    .total{
      background-color: rgba(0,0,0,0.5);
      color: #fff;
      font-size: 0.24rem;
      width: 1.2rem;
      line-height: 0.5rem;
      position: absolute;
      bottom: 0.24rem;
      right: 0.4rem;
      z-index: 9;
      text-align: center;
      border-radius: 0.25rem;
    }
    img{
      height: 5.64rem;
      width: 100%;
    }
    .slide_video_con{
      position: relative;
      .cover{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 5.64rem;
        background-color: rgba(0,0,0,0.3);
        i{
          color: #fff;
          font-size: 1.4rem;
        }
      }

    }
  }
  .title{
    font-size: 0.32rem;
    padding: 0.3rem 0.25rem;
    border-bottom: 1px solid #f5f5f5;
    font-weight: 800;
  }
  .row_con{
    padding: 0.5rem 0;
    .inner{
      border-right: 1px solid #f5f5f5;
      width: 25%;
      text-align: center;
      &:last-child{
        border: none;
      }
      .col_red{
        color: #ED3232;
        font-size: 0.32rem;
        font-weight: 800;
      }
      p{
        color: #616161;
        font-size: 0.24rem;
      }
    }
  }
  .content{
    font-size: 0.24rem;
    color: #424242;
    padding: 0 0.25rem;
    line-height: 0.42rem;
  }
  .pad_b{
    padding-bottom: 1.3rem;
  }
  .btn_con{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.4rem 0;
    z-index: 2;
    a{
      border-radius: 0.04rem;
      margin: 0 auto;
      background-color: #2F72F5;
      width: 6.9rem;
      height: 0.8rem;
      font-size: 0.32rem;
      color: #fff;
      img{
        width: 0.32rem;
        height: 0.32rem;
        margin-right: 0.2rem;
      }
    }
  }
</style>